// 各市州今日征订码洋占比模块
const state = {
  list: []
}

const mutations = {
  SET_DATA(state, data) {
    if (data && Array.isArray(data)) {
      state.list = data.map(item => ({
        cityName: item.cityName,
        my: item.my || 0,      // 码洋
        zdrs: item.zdrs || 0   // 征订人数
      }))
    } else {
      state.list = []
    }
  },
  RESET_DATA(state) {
    state.list = []
  }
}

const getters = {
  list: state => state.list,
  // 按码洋排序
  sortedByAmount: state => {
    return [...state.list].sort((a, b) => b.my - a.my)
  },
  // 总码洋
  totalAmount: state => {
    return state.list.reduce((sum, item) => sum + item.my, 0)
  },
  // 各市州占比
  withPercentage: (state, getters) => {
    const total = getters.totalAmount
    if (total === 0) return state.list
    return state.list.map(item => ({
      ...item,
      percentage: ((item.my / total) * 100).toFixed(2) + '%'
    }))
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
